import React from "react"
import ReactPaginate from 'react-paginate';

type Props = {
  inquirySubjectLabel: string,
  inquiryContentLabel: string,
  inquiryStatusLabel: string,
  inquiryCreatedAtLabel: string,
  inquiryStoreNameLabel: string,
  inquiries: any[],
  currentPage: number,
  totalPage: number
};

const OperatorBuyerInquiresList: React.FC<Props> = ({
  inquiries,
  inquirySubjectLabel,
  inquiryContentLabel,
  inquiryStatusLabel,
  inquiryCreatedAtLabel,
  inquiryStoreNameLabel,
  currentPage,
  totalPage
}) => {
  const handlePageClick = (event) => {
    // ページの切り替え。
    const selectedPage = event.selected + 1;
    window.history.pushState({page: selectedPage}, "", "?page=" + selectedPage);
    location.reload();
  }
  return (
    <div>
      <h1 className="margin_bottom_20">Buyer問い合わせ一覧</h1>
      <div className="display_flex justify_content_center">
        <table className="table-colored table-colored--buyer">
          <thead>
          <tr>
            <th>ID</th>
            <th>組織ID</th>
            <th>ユーザーID</th>
            <th>{inquiryStoreNameLabel}</th>
            <th>{inquirySubjectLabel}</th>
            <th>{inquiryContentLabel}</th>
            <th>{inquiryStatusLabel}</th>
            <th>{inquiryCreatedAtLabel}</th>
            <th></th>
          </tr>
          </thead>
          <tbody className="size_txt_smiddle">
            {inquiries.map(inquiry => (
              <tr key={inquiry.id}>
                <td>{inquiry.id}</td>
                <td>{inquiry.organizationId}</td>
                <td>{inquiry.userId}</td>
                <td>{inquiry.storeName}</td>
                <td>{inquiry.subject}</td>
                <td>{inquiry.content}</td>
                <td className={inquiry.isStatusCreated ? "txt_clr_charm" : ""}>{inquiry.status}</td>
                <td>{inquiry.createdAt}</td>
                <td>
                  <a href={inquiry.detailUrl}>
                    <div className="btn_semi_ellipse bg_clr_base txt_clr_clr">
                      <span>詳細</span>
                    </div>
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <ReactPaginate
        className="react-paging"
        breakLabel="..."
        nextLabel="›"
        forcePage={currentPage - 1}
        onPageChange={handlePageClick}
        activeClassName="react-paging-selected"
        pageRangeDisplayed={7}
        pageCount={totalPage}
        pageLinkClassName="react-paging__disable-animation-on-select"
        previousLabel="‹"
        renderOnZeroPageCount={null}
      />
    </div>
  )
}

export default OperatorBuyerInquiresList 
